export interface IStorageServiceStrategy {
  persistSessionOrigin(sessionOrigin?: string): void;
  getSessionOrigin(): string | null;
  persistRefreshToken(refreshToken: string): Promise<void>;
  getRefreshToken(): Promise<string | null>;
  forgetRefreshToken(): Promise<void>;
}

export class StorageService {
  public static getInstance(): StorageService {
    if (!StorageService._instance) {
      StorageService._instance = new StorageService();
    }

    return StorageService._instance;
  }

  private static _instance: StorageService;
  private _strategy: IStorageServiceStrategy;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}
  public set strategy(value: IStorageServiceStrategy) {
    this._strategy = value;
  }
  public get strategy(): IStorageServiceStrategy {
    if (!this._strategy) {
      throw new Error(
        'affiny-core/services/storage.ts you cannot call .strategy before configure it. Search StorageService.configure() method'
      );
    }

    return this._strategy;
  }

  public persistSessionOrigin(sessionOrigin: string) {
    this.strategy.persistSessionOrigin(sessionOrigin);
  }
  public getSessionOrigin() {
    return this.strategy.getSessionOrigin();
  }
  public async persistRefreshToken(refreshToken: string) {
    return this.strategy.persistRefreshToken(refreshToken);
  }
  public async getRefreshToken() {
    return this.strategy.getRefreshToken();
  }
  public async forgetRefreshToken() {
    return this.strategy.forgetRefreshToken();
  }
}

export const storageService = StorageService.getInstance();
